export interface BoundsModel {
    miny: number;
    minx: number;
    maxy: number;
    maxx: number;
    crs?: string;
}
